


// src/components/BottomNav.js
import React from 'react';
import { BottomNavigation, BottomNavigationAction, Badge } from '@mui/material';
import { Home, Info, ShoppingCart, Call, Share } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { useAdmin } from '../context/AppContext';

const BottomNav = () => {
  const [value, setValue] = React.useState(0);
  const navigate = useNavigate();
  const { cartItems } = useCart();
  const { adminProfile } = useAdmin();

  const handleNavigation = (newValue) => {
    setValue(newValue);

    if (newValue === 3) { // Index for "Call" button
      // Open the phone dialer with the specified number
      window.open(`tel:${adminProfile?.whatsapp}`, '_self');
    } else if (newValue === 4) { // Index for "Share" button
      const websiteURL = window.location.origin; // Base URL of the application
      const message = `Check out this website: ${websiteURL}`;
      const encodedMessage = encodeURIComponent(message);
      // Open WhatsApp with the prefilled message
      window.open(`https://wa.me/?text=${encodedMessage}`, '_blank');
    } else {
      const paths = ['/', '/about', '/cart', '/call', '/share'];
      navigate(paths[newValue]);
    }
  };

  return (
    <BottomNavigation value={value} onChange={(event, newValue) => handleNavigation(newValue)} showLabels>
      <BottomNavigationAction label="Home" icon={<Home />}
        sx={{
          color: value === 0 ? 'primary' : 'gray',  // Active icon color
          '&.Mui-selected': { color: 'primary',backgroundColor: 'transparent', },   // Active state color change
          backgroundColor: 'transparent',      // Remove background color effect
        }} />
      <BottomNavigationAction label="About" icon={<Info />}
        sx={{
          '&.Mui-selected': {
            color: 'primary',
            backgroundColor: 'transparent',
          },
        }} />
      {/* <BottomNavigationAction
        label="Cart"
        icon={
          <Badge badgeContent={cartItems.length} color="secondary">
            <ShoppingCart sx={{ fontSize: 30 }} />
          </Badge>
        }
        sx={{
          '&.Mui-selected': {
            color: 'primary',
            backgroundColor: 'transparent',
          },
        }}
      /> */}
      <BottomNavigationAction
        label="Cart"
        icon={
          <Badge
          badgeContent={cartItems.length}
          color="secondary"
          overlap="circular"
          sx={{
            '.MuiBadge-dot': {
              backgroundColor: '#c9a56a', // Custom background color for the badge
            },
          }}
        >
            <ShoppingCart sx={{ fontSize: 24, color: 'white' }} />
          </Badge>
        }
        sx={{
          '&.Mui-selected': { color: (theme) => theme.palette.primary.main, },
          backgroundColor: (theme) => theme.palette.primary.main,   // Red background color
          color: 'white',               // White icon color
          borderRadius: '50%',          // Make it fully round
          width: '60px',                // Set explicit width for round shape
          height: '60px',               // Set explicit height for round shape
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
          marginTop: '-12px',           // Adjust position if needed to align with other icons
        }}
      />
      <BottomNavigationAction label="Call" icon={<Call />}
        sx={{
          '&.Mui-selected': {
            color: 'primary',
            backgroundColor: 'transparent',
          },
        }} />
      <BottomNavigationAction label="Share" icon={<Share />}
        sx={{
          '&.Mui-selected': {
            color: 'primary',
            backgroundColor: 'transparent',
          },
        }} />
    </BottomNavigation>
  );
};

export default BottomNav;
